export default {"src":"/_next/static/media/arrows.0b501303.svg","height":25,"width":24,"blurWidth":0,"blurHeight":0};